<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-wifi`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M24 35c1.105 0 2.07.597 2.59 1.486L24 39.076l-2.59-2.59A2.999 2.999 0 0124 35zm0-9c3.588 0 6.808 1.574 9.007 4.07l-2.837 2.837A7.983 7.983 0 0024 30a7.984 7.984 0 00-6.17 2.906l-2.837-2.836A11.971 11.971 0 0124 26zm0-8a19.946 19.946 0 0114.67 6.406l-2.831 2.831A15.958 15.958 0 0024 22c-4.692 0-8.912 2.02-11.839 5.237l-2.83-2.831A19.946 19.946 0 0124 18zm0-9c8.282 0 15.753 3.472 21.037 9.039l-2.83 2.83C37.649 16.023 31.178 13 24 13c-7.177 0-13.648 3.024-18.207 7.868l-2.83-2.83C8.247 12.473 15.718 9 24 9z"/></svg>
</template>
<script>

export default {
  name: 'IconWifi',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
